// Hardcoded prompts for AI content generator dropdown
// These match prompts in aiplatform/agents-config/smart-reply.agent/
// No need to fetch from backend API anymore
// Organized in groups to show dividers between sections

// Prompt objects - defined once and reused
const PROMPT_REWRITE_IT = {
  uid: 'prmpt-smart-reply-00002',
  title: 'Rewrite it',
  icon: 'icon-Sync',
  order: 1,
  requiredVariables: [],
  optionalVariables: [],
  metadata: {
    configuration_key: 'rewrite',
  },
};

const PROMPT_WRITE = {
  uid: 'prmpt-smart-reply-00002',
  title: 'Write with AI',
  icon: 'icon-Sparkles',
  order: 1,
  requiredVariables: [],
  optionalVariables: [],
  metadata: {
    configuration_key: 'generate',
  },
};

const PROMPT_CUSTOM_INSTRUCTIONS = {
  uid: 'prmpt-smart-reply-00003',
  title: 'Give custom instructions',
  icon: 'icon-Promp-list',
  order: 2,
  requiredVariables: [],
  optionalVariables: [],
  metadata: {
    configuration_key: 'rewrite_with_custom_instructions',
  },
};

const PROMPT_MAKE_SHORTER = {
  uid: 'prmpt-smart-reply-00010',
  title: 'Make it shorter',
  icon: 'icon-exit-full-size',
  order: 1,
  requiredVariables: [],
  optionalVariables: [],
  metadata: {
    configuration_key: '',
  },
  disableWhenNoText: true,
};

const PROMPT_MAKE_LONGER = {
  uid: 'prmpt-smart-reply-00011',
  title: 'Make it longer',
  icon: 'icon-Expand-alt',
  order: 2,
  requiredVariables: [],
  optionalVariables: [],
  metadata: {
    configuration_key: '',
  },
  disableWhenNoText: true,
};

const PROMPT_MAKE_FRIENDLY = {
  uid: 'prmpt-smart-reply-00012',
  title: 'Make it friendly',
  icon: 'icon-smile',
  order: 3,
  requiredVariables: [],
  optionalVariables: [],
  metadata: {
    configuration_key: '',
  },
  disableWhenNoText: true,
};

const AI_GENERATOR_PROMPTS = {
  'smart-reply': [
    {
      uid: 'smart-reply-group-1',
      title: null, // No title for first group
      order: 1,
      metadata: {
        configuration_key: 'generate', // Marks this group as having both generate and rewrite items
      },
      prompts: [
        PROMPT_WRITE,
        PROMPT_REWRITE_IT,
        PROMPT_CUSTOM_INSTRUCTIONS,
      ],
    },
    {
      uid: 'smart-reply-group-2',
      title: 'REWRITE',
      order: 2,
      metadata: {
        configuration_key: 'generate', // Marks this group as having both generate and rewrite items
      },
      prompts: [
        PROMPT_MAKE_SHORTER,
        PROMPT_MAKE_LONGER,
        PROMPT_MAKE_FRIENDLY,
      ],
    },
    {
      uid: 'smart-reply-group-mobile',
      title: 'REPLY WITH AI',
      order: 1,
      showInMobile: true,
      metadata: {
        configuration_key: 'generate', // Marks this group as having both generate and rewrite items
      },
      prompts: [
        PROMPT_WRITE,
        PROMPT_REWRITE_IT,
        PROMPT_MAKE_SHORTER,
        PROMPT_MAKE_FRIENDLY,
      ],
    },
  ],
};

export default AI_GENERATOR_PROMPTS;
